import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import { Modal, TextInput } from '../../../../../../components'
import {
  Address,
  Functions,
  Institution,
  Strategy
} from './components'

import { ContactSource } from '../../../../../../utils'

import './job.component.scss'

/**
 * Contact Job Create/Edit Form
 */
class JobForm extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)

    const job = (props && props.job) || {}
    this.state = {
      error: {
        isError: false,
        message: ''
      },
      title: (job.value && job.value.title) || '',
      phone: '',
      directPhone: (job.value && job.value.direct_telephone) || '',
      email: (job.value && job.value.email) || '',
      institution: null,
      address: null,
      functions: [],
      addressOptions: [],
      strategy: {
        summary: (job.strategy && job.strategy.summary) || ''
      }
    }
  }

  /**
   * Component did update
   * @param prevProps
   * @param prevState
   */
  componentDidUpdate (prevProps, prevState) {
    const { address, institution } = this.state

    if (prevState.institution !== institution) {
      this.setState({
        error: { isError: !institution, message: '' },
        addressOptions: (institution && institution.address) || []
      })
    }

    if (prevState.address !== address) {
      this.setState({ phone: (address && address.phone) || '' })
    }
  }

  /**
   * Set job object
   * @returns {*}
   */
  setJobObject = () => {
    const { title, institution, directPhone, phone, email, functions, address, addressOptions } = this.state
    const institutionDetail = {
      _id: institution._id,
      q4_entity_id: institution.q4_entity_id,
      factset_entity_id: institution.factset_entity_id,
      institution_name: institution.institution_name,
      institution_type: institution.type || institution.institution_type
    }

    const addressDetail = address ? address :
      addressOptions && Array.isArray(addressOptions) && addressOptions.find((item) => item && item.hq)

    return {
      title,
      ...institutionDetail,
      ...addressDetail,
      functions: (functions || []).map((option) => option && option.value),
      phone: phone || (addressDetail && (addressDetail.phone || addressDetail.telephone)),
      direct_telephone: directPhone,
      email
    }
  }

  /**
   * Set strategy object
   * @returns {*}
   */
  setStrategyObject = () => {
    const { strategy } = this.state
    const job = this.setJobObject()

    for (let property in strategy) {
      if (strategy.hasOwnProperty(property) && Array.isArray(strategy[property])) {
        strategy[property] = strategy[property].map((option) => (option && option.value))

        if (!strategy[property].length) {
          delete strategy[property]
        }
      }
    }

    if (isEmpty(strategy)) {
      return null
    }

    strategy['source'] = ContactSource.SSOT
    strategy['q4_entity_id'] = job && job.q4_entity_id
    strategy['factset_entity_id'] = job && job.factset_entity_id

    return strategy
  }

  /**
   * On contact job save add job to jobs array
   */
  onJobSave = () => {
    const { job, values, setFieldValue, onClose } = this.props
    const { error, institution } = this.state
    const index = job && job.index

    if (!institution) {
      !error.isError && this.setState({ error: { isError: !institution, message: '' } })
      return null
    }

    const selected = this.setJobObject()
    const selectedStrategy = this.setStrategyObject()

    // check if job with the same institution already exists
    if ([].concat(values.jobs || []).some((value, idx) => (index !== idx) && (value._id === selected._id))) {
      this.setState({
        error: {
          isError: true,
          message: `Job with ${selected.institution_name} Institution already exists.`
        }
      })
      return null
    }

    (Number(index) >= 0) ?
      values.jobs.splice(index, 1, selected) :
      values.jobs = [].concat(values.jobs || [], selected)

    values.strategy = (values.strategy || [])
      .filter((strategy) => (strategy && strategy.factset_entity_id !== institution.factset_entity_id))

    values.strategy = selectedStrategy ? [].concat(values.strategy || [], selectedStrategy) : values.strategy

    setFieldValue(values.jobs)
    setFieldValue(values.strategy)
    onClose()
  }

  /**
   * Render
   * @return {*}
   */
  render () {
    const { job, searchInstitutions, loading, suggestions, clearSuggestions, onClose } = this.props
    const { error, title, phone, directPhone, email, institution, address, addressOptions, functions, strategy } = this.state

    const current = (job && job.value) || {}
    const buttons = [
      {
        label: 'Cancel',
        ui: 'shaded',
        onClick: onClose
      },
      {
        label: 'Save',
        ui: 'citrus',
        onClick: this.onJobSave
      }
    ]

    return (
      <Modal
        visible
        fullscreen
        badge='q4i-institution-2pt'
        title={(current && current._id) ? 'Edit Institution' : 'Add Institution'}
        buttons={buttons}
        onClose={onClose}>

        <Grid container spacing={3} className='contact-job_modal-content'>
          <Grid item xs={6} container spacing={3} alignItems='flex-start'>

            <Grid item xs={12} container spacing={6}>
              <Grid item xs>
                <Institution
                  error={error}
                  job={current}
                  searchInstitutions={searchInstitutions}
                  loading={loading}
                  suggestions={suggestions}
                  clearSuggestions={clearSuggestions}
                  onValueChange={(institution) => this.setState({ institution })} />
              </Grid>
            </Grid>

            <Grid item xs>
              <div className='section_title'>General Information</div>
            </Grid>

            <Grid item xs={12} container spacing={6}>
              <Grid item xs>
                <Address
                  job={current}
                  institution={institution}
                  address={address}
                  options={addressOptions}
                  onValueChange={(address) => this.setState({ address })} />
              </Grid>
            </Grid>

            {/* job information */}
            <Grid item xs={6} container spacing={3} direction='column'>
              <Grid item xs>
                <div className='field field--text'>
                  <label className='field_label'>Job Title</label>
                  <TextInput
                    value={title}
                    onChange={(event) => this.setState({ title: event.target.value })} />
                </div>
              </Grid>
              <Grid item xs>
                <div className='field field--text'>
                  <label className='field_label'>Corporate Email</label>
                  <TextInput
                    value={email}
                    onChange={(event) => this.setState({ email: event.target.value })} />
                </div>
              </Grid>
              <Grid item xs>
                <Functions
                  job={current}
                  functions={functions}
                  onValueChange={(functions) => this.setState({ functions })} />
              </Grid>
            </Grid>

            {/* contact */}
            <Grid item xs={6} container spacing={3} direction='column'>
              <Grid item xs>
                <div className='field field--text'>
                  <label className='field_label'>Corporate Phone</label>
                  <TextInput
                    value={phone}
                    onChange={(event) => this.setState({ phone: event.target.value })} />
                </div>
              </Grid>
              <Grid item xs>
                <div className='field field--text'>
                  <label className='field_label'>Corporate Direct Phone</label>
                  <TextInput
                    value={directPhone}
                    onChange={(event) => this.setState({ directPhone: event.target.value })} />
                </div>
              </Grid>
            </Grid>

            {/* strategy */}
            <Strategy
              current={strategy}
              jobStrategy={(job && job.strategy) || {}}
              onChange={(event) => this.setState({ strategy: { ...strategy, summary: event.target.value } })}
              onValueChange={(options, list) => this.setState(strategy[list] = options)} />

          </Grid>
        </Grid>
      </Modal>
    )
  }
}

JobForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  job: PropTypes.object,
  searchInstitutions: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  suggestions: PropTypes.array,
  clearSuggestions: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired
}

JobForm.defaultProps = {
  visible: false,
  values: {},
  suggestions: []
}

export default JobForm
